import React, { useEffect, useState } from 'react';

import { cn, DefaultTooltip, Select } from 'twyne-new.ui';

import { useBubbleTiptap } from '../bubble/Bubble';

export default function SelectDropdown({ value, creatable = false, options: defaultOptions, onChange, tooltipText, darkMode = false }) {
  const { setBubblePopover, isBubbleContext } = useBubbleTiptap()
  const [options, setOptions] = useState()

  useEffect(() => {
    if (options === undefined) {
      setOptions(defaultOptions)
    }
  }, [options, defaultOptions, value])

  useEffect(() => {
    if (value && options?.length && !options.find(option => option === value || option?.value === value)) {
      setOptions(prev => [...prev, value])
    }
  }, [value, options])

  if (!options) {
    return null
  }

  const hoverClass = isBubbleContext ? 'hover:bg-gray-200' : 'hover:bg-gray-200 dark:hover:bg-gray-950'

  return <>
    <DefaultTooltip content={tooltipText}>
      <Select
        onMenuOpen={() => setBubblePopover(true)}
        onMenuClose={() => setBubblePopover(false)}
        options={options[0]?.value ? options : options.map(option => ({ label: option, value: option }))}
        value={value}
        onChange={option => onChange(option?.value)}
        controlClassName={cn('py-1 min-h-0! border-0 gap-2', hoverClass)}
        insideSheet
        creatable={creatable}
        formatCreateLabel={value => `Create: "${value}px"`}
        isValidNewOption={value => value && !isNaN(value)}
        newOptionCreator={value => ({ label: `${value}px`, value: `${value}px` })}
        darkMode={darkMode}
        placeholder={tooltipText}
      />
    </DefaultTooltip >
  </>
}
